import { Flex, Input } from '@chakra-ui/react'

import { ActionButton } from '../../../../components/ActionButton'
import { SiteColor } from './siteColors'

// O mesmo risco vermelho do "sem cor" da paleta do editor (`RichTextField.css`).
const NO_COLOR_SWATCH = {
  backgroundImage: 'linear-gradient(to top right, #fff calc(50% - 1px), #e53e3e, #fff calc(50% + 1px)) !important'
}

interface ISiteColorInputProps {
  id?: string
  /** O valor gravado no banner. Vazio é "a cor padrão do site". */
  stored?: string | null
  /** O que o site desenha com o campo vazio; `null` é sem cor. */
  fallback: SiteColor
  disabled?: boolean
  /** Recebe `''` ao limpar: o `BannerService` envia a cor vazia e a API grava `null`. */
  onChange: (value: string) => void
}

/**
 * Seletor de cor que mostra o que o site desenha: um campo vazio aparece com a cor padrão do site,
 * e não preto, ou riscado quando lá ele fica sem cor (fundo transparente, sem gradiente). Com uma
 * cor gravada, o botão ao lado volta o campo ao padrão.
 */
export default function SiteColorInput({ id, stored, fallback, disabled, onChange }: ISiteColorInputProps) {
  const value = stored || fallback

  return (
    <Flex align="center" gap={1}>
      <Input
        id={id}
        type="color"
        p={0}
        color="gray.900"
        borderWidth="1px"
        borderColor="black"
        borderRadius="md"
        w="2.5rem"
        h="2.5rem"
        // Sem cor, o seletor abre num quase preto, e não no preto: o `input` só avisa quando a cor
        // muda, e escolher `#000000` sobre um valor `#000000` não chegaria ao formulário.
        value={value ?? '#010101'}
        title={value ? undefined : 'Sem cor no site'}
        // Um pseudo-elemento por regra: o navegador descarta a lista inteira ao ver um que não conhece.
        sx={value ? undefined : { '&::-webkit-color-swatch': NO_COLOR_SWATCH, '&::-moz-color-swatch': NO_COLOR_SWATCH }}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
      />
      {!!stored && !disabled && <ActionButton action="clear" label="Limpar cor" mr={0} onClick={() => onChange('')} />}
    </Flex>
  )
}
